// extracted by mini-css-extract-plugin
export default {"NavigateBackButtonContainer":"NavigateBackButton_NavigateBackButtonContainer__OKfgk","NavigateBackImage":"NavigateBackButton_NavigateBackImage__GLRYS"};